import React from 'react'

const Star = ({ fill = 'none' }) => (
  <svg width="18" height="17" viewBox="0 0 18 17" xmlns="http://www.w3.org/2000/svg">
    {' '}
    <defs>
      {' '}
      <linearGradient id="halfGradient">
        <stop offset="50%" stopColor="#228E82" />
        <stop offset="50%" stopColor="#ccc" />{' '}
      </linearGradient>{' '}
    </defs>{' '}
    <path
      d="M8.41473 0.943983C8.70692 0.252395 9.70206 0.252396 9.99424 0.943985L11.7187 5.02586C11.842 5.31742 12.1205 5.51663 12.4402 5.54186L16.9163 5.89515C17.6747 5.95501 17.9822 6.88676 17.4044 7.37405L13.9941 10.25C13.7505 10.4555 13.644 10.7778 13.7185 11.085L14.7604 15.3852C14.9369 16.1137 14.1319 16.6897 13.4825 16.2993L9.65034 13.9948C9.37661 13.8302 9.03236 13.8302 8.75864 13.9948L4.92642 16.2993C4.27712 16.6897 3.47204 16.1137 3.64856 15.3852L4.69049 11.085C4.76491 10.7778 4.65853 10.4555 4.41494 10.25L1.00457 7.37405C0.426757 6.88676 0.734276 5.95501 1.49267 5.89515L5.96883 5.54186C6.28856 5.51663 6.56706 5.31742 6.69024 5.02586L8.41473 0.943983Z"
      fill={fill}
    />{' '}
  </svg>
)

export const IconStarRating = ({ rating }) => {
  const fullStars = Math.floor(rating)
  const hasHalfStar = rating - fullStars >= 0.25 && rating - fullStars < 0.75
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0)

  const stars: JSX.Element[] = []

  for (let i = 0; i < fullStars; i++) {
    stars.push(<Star key={`full-${i}`} fill="#228E82" />)
  }

  if (hasHalfStar) {
    stars.push(<Star key="half" fill="url(#halfGradient)" />)
  }

  for (let i = 0; i < emptyStars; i++) {
    stars.push(<Star key={`empty-${i}`} fill="#ccc" />)
  }

  return (
    <div className="star-rating-svg">
      {stars}
      <span className="rating-number">{rating.toFixed(1)}</span>
    </div>
  )
}
